/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedForceSearchLink_itemSearch = {
    readonly pageType: string | null;
    readonly searchCorrections: {
        readonly forceSearchUri: string | null;
        readonly originalSearchTerm: string | null;
        readonly semanticSearchTerm: string | null;
        readonly classificationSearchTerm: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedSearchSuggestions_itemSearch">;
    readonly " $refType": "SbSharedForceSearchLink_itemSearch";
};
export type SbSharedForceSearchLink_itemSearch$data = SbSharedForceSearchLink_itemSearch;
export type SbSharedForceSearchLink_itemSearch$key = {
    readonly " $data"?: SbSharedForceSearchLink_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedForceSearchLink_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedForceSearchLink_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "searchCorrections",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchCorrectionsType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "forceSearchUri",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "originalSearchTerm",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "semanticSearchTerm",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "classificationSearchTerm",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedSearchSuggestions_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '96d4931da6ef15b1647d22b4e1b07720';
export default node;
